<template>
    <div>
        <app-layout>
	        <template v-slot:header>
		        <Header :title="$t('vinov_installments')"
                        :isColumns="true"
                        :isNewButton="checkPermission('vinovinstallment_store')"
		                @new-button-click="add"
		                @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ br2space(column.label) }}
                            </b-form-checkbox>
                        </div>
                    </template>
		        </Header>
	        </template>
	        <template v-slot:header-mobile>
		        <HeaderMobile :title="$t('vinov_installments')"
                              :isColumns="true"
                              :isNewButton="checkPermission('vinovinstallment_store')"
		                      @new-button-click="add"
		                      @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ br2space(column.label) }}
                            </b-form-checkbox>
                        </div>
                    </template>
		        </HeaderMobile>
	        </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
                <b-row>
                    <b-col sm="6" md="4" lg="3" xl="2">
                        <b-form-group :label="$t('period_code')">
                            <payment-periods-selectbox v-model="datatable.queryParams.filter.period_id">
                            </payment-periods-selectbox>
                        </b-form-group>
                    </b-col>

                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                       @on-page-change="onPageChange" @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="modal" id="formModal" size="lg">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t(id == 0 ? 'add' : 'edit') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div class="row mb-5 align-items-center">
                        <div class="col-12">
                            <ValidationObserver ref="storeForm">
                                <b-row>
                                    <b-col cols="12" md="6">
                                        <ValidationProvider name="period_id" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('periods')">
                                                <payment-periods-selectbox
                                                    v-model="form.period_id"
                                                    :validateError="errors[0]"/>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <ValidationProvider name="interest_rate" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('interest_rate')">
                                                <b-form-input type="number" min="0" max="100" v-model="form.interest_rate"
                                                              :state="errors[0] ? false : null" />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <ValidationProvider name="down_payment_rate" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('down_payment_rate')">
                                                <b-form-input type="number" min="0" max="100" v-model="form.down_payment_rate"
                                                              :state="errors[0] ? false : null" />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <ValidationProvider name="number_of_installments" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('number_of_installments')">
                                                <b-form-input type="number" min="1" v-model="form.number_of_installments"
                                                              :state="errors[0] ? false : null" />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('start_date')">
                                                <select-date v-model="form.start_date" :is-time="true" :state="errors[0] ? false : null" />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <ValidationProvider name="end_date" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('end_date')">
                                                <select-date v-model="form.end_date" :is-time="true" :state="errors[0] ? false : null" />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                            </ValidationObserver>
                        </div>
                        <div class="col-12 mt-3 d-flex">
                            <b-button @click="store" type="button" variant="primary" class="btn-lg mr-2">
                                {{ $t('save') | toUpperCase }}
                            </b-button>
                        </div>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

// Components
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox"
import SelectDate from "@/components/interactive-fields/SelectDate";

// Services
import VinovInstallmentService from "@/services/VinovInstallmentService";

// Other
import qs from 'qs'
import {ValidationObserver, ValidationProvider} from "vee-validate";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        ValidationProvider,
        ValidationObserver,

        DatatableFilter,
        Datatable,
        CommonModal,
        PaymentPeriodsSelectbox,
        SelectDate
    },
    metaInfo() {
        return {
            title: this.$t('vinov_installments')
        }
    },
    data() {
        return {
            id: 0,
            form: {},
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 w-100-below-lg align-middle',
                        buttons: [
                            {
                                text: this.$t('edit'),
                                class: 'ri-edit-box-line',
                                permission:'vinovinstallment_update',
                                callback: (row) => {
                                    this.id = row.id;
                                    this.loadData();
                                }
                            },
                            {
                                text: this.$t('delete'),
                                permission:'vinovinstallment_delete',
                                class: 'ri-delete-bin-2-line',
                                callback: (row) => {
                                    this.delete(row.id);
                                }
                            },
                        ]
                    },
                    {
                        label: this.spaceToBR(this.toUpperCase('period')),
                        field: this.getLocaleField('period_code'),
                        sortable: false,
                        hidden:false
                    },
                    {
                        label: this.$t('number_of_installments'),
                        field: 'number_of_installments',
                        sortable: false,
                        hidden:false
                    },
                    {
                        label: this.$t('interest_rate'),
                        field: 'interest_rate',
                        sortable: false,
                        hidden:false
                    },
                    {
                        label: this.$t('down_payment_rate'),
                        field: 'down_payment_rate',
                        sortable: false,
                        hidden:false
                    },
                    {
                        label: this.$t('start_date'),
                        field: this.getLocaleField('start_date'),
                        sortable: false,
                        hidden:false
                    },
                    {
                        label: this.$t('end_date'),
                        field: this.getLocaleField('end_date'),
                        sortable: false,
                        hidden:false
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            }
        }
    },
    methods: {
        filter() {
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return VinovInstallmentService.getAll(config)
                                         .then((response) => {
                                             this.datatable.rows = response.data.data
                                             this.datatable.total = response.data.pagination.total
                                         })
                                         .finally(() => {
                                             this.datatable.isLoading = false;
                                         });
        },
        loadData() {
            if (this.id > 0) {
                VinovInstallmentService.get(this.id)
                                      .then(response => {
                                          this.$refs.storeForm.reset();
                                          this.form = response.data.data;
                                          this.$bvModal.show('formModal');
                                      })
                                      .catch(error => {
                                          if (error.data.message) {
                                              this.$toast.error(this.$t('api.' + error.data.message));
                                          }
                                      });
            }
        },
        async store() {
            const isValid = await this.$refs.storeForm.validate()
            if (isValid) {
                if (this.id == 0) {

                    VinovInstallmentService.store(this.form, this.value)
                                          .then((response) => {
                                              this.$toast.success(this.$t("api." + response.data.message));
                                              this.$bvModal.hide('formModal');
                                              this.getRows();
                                          })
                                          .catch((error) => {
                                              this.showErrors(error, this.$refs.storeForm)
                                          });
                }
                else {
                    VinovInstallmentService.update(this.id, this.form)
                                          .then((response) => {
                                              this.$toast.success(this.$t("api." + response.data.message));
                                              this.$bvModal.hide('formModal');
                                              this.getRows();
                                          })
                                          .catch((error) => {
                                              this.showErrors(error, this.$refs.storeForm)
                                          })
                }

            }
        },
        delete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                    icon: 'question'
                })
                .then(() => {
                    VinovInstallmentService.del(id)
                        .then((response) => {
                            this.filter();
                            this.$toast.success(this.$t('api.' + response.data.message));
                        })
                        .catch((error) => {
                            this.$toast.error(this.$t('api.' + error.data.message));
                        });
                });
        },
        add() {
            this.id = 0;
            this.$refs.storeForm.reset();
            this.form = {};
            this.$bvModal.show('formModal');
        }
    }
};
</script>

